module.exports = "/_next/static/images/harajuku_lunch_salad-d1be93a31a4f3452801b70c57aa94720.jpg";